import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

interface NeonButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

export function NeonButton({ children, className, disabled, ...props }: NeonButtonProps) {
  return (
    <button
      {...props}
      disabled={disabled}
      className={clsx(
        'px-6 py-2 rounded-full text-cyan-300 font-bold bg-cyan-900/50 border-2 border-cyan-400/50',
        'hover:bg-cyan-700/50 hover:text-white hover:shadow-cyan-400/20 hover:shadow-lg',
        'transition-all duration-300 ease-in-out transform hover:scale-105',
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:hover:shadow-none',
        className
      )}
    >
      {children}
    </button>
  );
}